module.exports = __webpack_public_path__ + "images/category_lp/pc/lppc-Target_Bar_bg_ddb375a562ed385acd9a4f9b2cf67067.png";